/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressViewModel } from './AddressViewModel';
import {
    AddressViewModelFromJSON,
    AddressViewModelFromJSONTyped,
    AddressViewModelToJSON,
} from './AddressViewModel';

/**
 * 
 * @export
 * @interface OrganisationAddressesViewModel
 */
export interface OrganisationAddressesViewModel {
    /**
     * 
     * @type {number}
     * @memberof OrganisationAddressesViewModel
     */
    partyId: number;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof OrganisationAddressesViewModel
     */
    physicalAddress?: AddressViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof OrganisationAddressesViewModel
     */
    postalAddress?: AddressViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof OrganisationAddressesViewModel
     */
    registeredAddress?: AddressViewModel;
}

/**
 * Check if a given object implements the OrganisationAddressesViewModel interface.
 */
export function instanceOfOrganisationAddressesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;

    return isInstance;
}

export function OrganisationAddressesViewModelFromJSON(json: any): OrganisationAddressesViewModel {
    return OrganisationAddressesViewModelFromJSONTyped(json, false);
}

export function OrganisationAddressesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganisationAddressesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'physicalAddress': !exists(json, 'PhysicalAddress') ? undefined : AddressViewModelFromJSON(json['PhysicalAddress']),
        'postalAddress': !exists(json, 'PostalAddress') ? undefined : AddressViewModelFromJSON(json['PostalAddress']),
        'registeredAddress': !exists(json, 'RegisteredAddress') ? undefined : AddressViewModelFromJSON(json['RegisteredAddress']),
    };
}

export function OrganisationAddressesViewModelToJSON(value?: OrganisationAddressesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PhysicalAddress': AddressViewModelToJSON(value.physicalAddress),
        'PostalAddress': AddressViewModelToJSON(value.postalAddress),
        'RegisteredAddress': AddressViewModelToJSON(value.registeredAddress),
    };
}

